export const QUIZ = [
  {
    id: 'q1',
    number: 1,
    question: 'How old do you FEEL most days compared to your actual age?',
    options: [
      'Younger than my age',
      'About my age',
      'Older than my age',
      'Much older than my age',
    ],
    insight:
      'Many people assume "feeling older" is normal aging. Often, it can relate to how efficiently your cells create energy.',
    overline: 'Cellular Energy',
  },
  {
    id: 'q2',
    number: 2,
    question: 'How often do you feel drained by the middle of the day?',
    options: ['Rarely', 'Sometimes', 'Often', 'Almost daily'],
    insight:
      'Your body creates energy inside mitochondria. As we age, that process can become less efficient.',
    overline: 'Mitochondria',
  },
  {
    id: 'q3',
    number: 3,
    question: 'Which matters most to you right now?',
    options: [
      'More energy',
      'Better heart health',
      'Healthy aging',
      'Better stamina',
      'Mental sharpness',
    ],
    insight:
      'Certain nutrients support multiple systems at once because energy production impacts nearly everything.',
    overline: 'Whole-Body Vitality',
  },
  {
    id: 'q4',
    number: 4,
    question: 'Do you currently take any daily supplements?',
    options: ['Yes, regularly', 'Sometimes', 'Rarely', 'Never'],
    insight:
      'Many people supplement vitamins, but overlook compounds naturally involved in cellular energy production.',
    overline: 'Nutrient Profile',
  },
  {
    id: 'q5',
    number: 5,
    question: 'How would you rate your recovery after physical activity?',
    options: ['Excellent', 'Good', 'Slower than it used to be', 'Poor'],
    insight:
      'Recovery often changes with age because the body has to work harder to restore energy reserves.',
    overline: 'Recovery Capacity',
  },
  {
    id: 'q6',
    number: 6,
    question: 'Has your doctor ever discussed heart health, circulation, or cholesterol with you?',
    options: ['Yes', 'No', 'Not yet, but I think about it', 'Prefer not to say'],
    insight:
      'The heart is one of the most energy-demanding organs in the body, which is why mitochondrial support matters.',
    overline: 'Heart Health',
  },
  {
    id: 'q7',
    number: 7,
    question: 'What age range are you in?',
    options: ['Under 40', '40–49', '50–59', '60–69', '70+'],
    insight:
      'Natural CoQ10 levels may decline with age, which is one reason many adults begin exploring supplementation later in life.',
    overline: 'Age & CoQ10',
  },
  {
    id: 'q8',
    number: 8,
    question: 'If you could improve one thing in the next 30 days, what would it be?',
    options: [
      'Daily energy',
      'Motivation',
      'Endurance',
      'Heart confidence',
      'Overall vitality',
    ],
    insight:
      'Small internal improvements often create visible changes in how people feel day to day.',
    overline: 'Your Priority',
  },
];

export const QUIZ_LENGTH = QUIZ.length;
export const OFFER_URL = 'https://youngagain.com/pages/coq10-ubiquinone';
